/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { forexGetPrices } from "../../funcs/forexGetPrices.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetForexPricesRequest$inboundSchema,
};

export const tool$forexGetPrices: ToolDefinition<typeof args> = {
  name: "forex-get-prices",
  description: `Get forex data for one currency

Returns forex price history for a given currency code.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await forexGetPrices(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
